import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Products from "@/components/site/Products";
import ProposalAI from "@/components/site/ProposalAI";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="grain relative">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Products />
        <ProposalAI />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
